export enum EmailAttachmentEnum {
    Base64 = "Base64",
    FileName = "FileName"
}
